// One engineering ticket as the reports see it: the same fields the master Sheet's "Form Responses" tab holds, plus what only this app knows.
// The ticket's free text lives apart (see ReportRepository) so the list the reports load stays small.
export interface TicketRow {
  // `sheet-<hash>` for a ticket imported from the Sheet, the submission ID for one raised in the app.
  id: string;
  source: "sheet" | "app";
  // ISO 8601 UTC.
  raisedAt: string;
  // Submitted By.
  raiser: string;
  businessUnit?: string;
  company?: string;
  feature?: string;
  severity?: string;
  pricingPlan?: string;
  ticketType?: string;
  // Been to CS Huddle?
  huddle?: string;
  // Team who worked on the ticket.
  team?: string;
  // Ticket Assignee, without the leading "@".
  engineer?: string;
  // The tracker List's status, for example "Complete - Technical Support".
  status?: string;
  closedAt?: string;
  pickedUpAt?: string;
  inProgressAt?: string;
  waitingCustomerAt?: string;
  waitingCsAt?: string;
  hasFiles: boolean;
  // Only for tickets raised in the app.
  submissionId?: string;
  // The tracker List item, which the status sync watches.
  listItemId?: string;
  jiraKey?: string;
  triageVerdict?: "ticket_needed" | "not_needed";
  triageUnavailable?: boolean;
  aiTicketType?: string;
  ticketTypeCorrected?: boolean;
  overridden?: boolean;
  // Why the person raised it despite a "no ticket" verdict.
  overrideReason?: string;
  impactVerdict?: string;
  // Only on a submission closed without a ticket: the person who raised it, or the hourly sweep when nobody acted.
  closedBy?: "person" | "system";
}

// A ticket the reports show before the tracker has reported any progress on it.
export const NEW_TICKET_STATUS = "New";

// These statuses are "closed": the same set the Looker dashboard counts (992 of the 1,063 tickets in the October 2026 export).
export const CLOSED_STATUSES: readonly string[] = [
  "Complete - Technical Support",
  "Complete - CS Learning",
  "Complete - other",
  "Managed in Jira",
  "ENG Ticket Raised Incorrectly",
];

export interface IncidentRow {
  id: string;
  createdAt: string;
  title: string;
  severity: string;
  types: string[];
  companiesImpacted: string;
  status: string;
  raiser: string;
  // When the owner declared it resolved.
  resolvedAt?: string;
  // The severity the form's AI suggested when it was raised, if the person asked for one.
  aiSeverity?: string;
  // Where the owner put the write-up, if they linked it.
  writeUpUrl?: string;
  jiraKey?: string;
  jiraUrl?: string;
  channelName?: string;
  channelUrl?: string;
}
